import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navState = useMemo(
    () => ({ from: `${location.pathname}${location.search || ""}` }),
    [location.pathname, location.search]
  );
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div data-testid="auth-loading" className="font-mono text-xs text-zinc-500 uppercase tracking-widest">
          Authenticating…
        </div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={navState} replace />;
  }
  if (requireAdmin && user.role !== "admin" && user.role !== "staff") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};
